import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Question } from '../../../../models/Question';
import { QuestionService } from '../../../../services/question.service';
import { QuestionFile } from '../../../../models/QuestionFile';
import { NgxSpinnerService } from 'ngx-spinner';
// tslint:disable-next-line:max-line-length
import { ConfirmationPageSuccessComponent } from '../../../../shared-components/confirmation-page-success/confirmation-page-success.component';
// tslint:disable-next-line:max-line-length
import { ConfirmationPageFailComponent } from '../../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
import { DataService } from '../../../../services/data.service';
import { Console } from '@angular/core/src/console';
import { Router } from '@angular/router';
import { VendorQuestion } from '../../../../models/VendorQuestion';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-vendor-support',
  templateUrl: './vendor-support.component.html',
  styleUrls: ['./vendor-support.component.scss']
})
export class VendorSupportComponent implements OnInit, OnDestroy {

  @Input('username') username: string;
  @Input('email') email: string;
  @Input('contractNum') contractNum: string;
  @Output('submitClick') submitClick: EventEmitter<any> = new EventEmitter();
  @Output('cancelClick') cancelClick: EventEmitter<any> = new EventEmitter();
  @ViewChild('FileInput') inputVariable: any;
  showSuccessConfirmation = false;
  showFailConfirmation = false;
  loginFailDescription = '';
  public yourJssiTeam: any;
  fileToUpload: File = null;
  textAreaModel: string;
  currTime: Date;
  reader: FileReader = new FileReader();
  showInvalidFileMessage = false;
  InvalidFileMessage: string;
  public fileData: Uint8Array;
  category = [

    { id: 0, name: 'My Invoice' },
    { id: 1, name: 'My Payment' },
    { id: 2, name: 'My Purchase Order' },
    { id: 3, name: 'Other Question' }
  ];
  selectedCategoryId: any;
  selectedCategoryIds: any[];
  userInfo:any;

  private alive = true;

  question: Question = new Question();
  questionFile: QuestionFile = new QuestionFile();
  historicalQuestions: VendorQuestion[];
  public isOpen = false;
  public oneAtATime = true;
  constructor(private questionService: QuestionService, private _router: Router,
              private spinner: NgxSpinnerService, private datasvc: DataService,
              public sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.showFailConfirmation=false;
    this.showSuccessConfirmation=false;
    this.yourJssiTeam = [1, 2, 3];
    this.userInfo = this.datasvc.userDisplayInfo;
    console.log(this.userInfo);
    this.username = this.userInfo.FirstName + ' ' + this.userInfo.LastName;
    this.email = this.userInfo.Email;
    this.getHistoricalQuestions();
  }

  getHistoricalQuestions() {
    this.questionService.getVendorQuestions(this.userInfo.GPVID)
    .takeWhile(() => this.alive)
    .subscribe(
      data => {
        this.historicalQuestions = data;
      }
    );
  }

  onSubmitClick() {
   // this.question = new Question();
   console.log('inside on submit');
   this.spinner.show();
    this.currTime = new Date();
    this.question.Email = this.email;
    this.question.Name = this.username;
    this.question.ContractNumber = this.userInfo.GPVID;
    this.question.CategoryID = this.selectedCategoryId;
    this.question.Category = this.category[this.selectedCategoryId].name;
    this.question.QDesc = this.textAreaModel;
    this.question.QDate = Date.now().toString();
    this.questionService.submitVendorQuestion(this.question)
    .takeWhile(() => this.alive)
    .subscribe(
      data => {
        this.spinner.hide();
        console.log('test..', data);
        this.showSuccessConfirmation = true;
        this.showFailConfirmation = false;
      },
      err => {
        this.spinner.hide();
        console.log(err);
        this.loginFailDescription = err._body;
        this.showFailConfirmation = true;
        this.showSuccessConfirmation = false;
      }
    );

  }

  onCancelClick() {
    this.cancelClick.emit(null);
  }

  getRemaining(textAreaModel: string, maximum: number): string {
    return `${textAreaModel ? maximum - textAreaModel.length : maximum} characters remaining`;
  }

  wait2sec() {
    return new Promise(function(resolve, reject) {
      setTimeout(function() {
        resolve();
      }, 2000);
    });
  }

  resetFileInput() {
    this.inputVariable.nativeElement.value = "";
  }

  readFile(files: FileList) {
    this.reader.onload = e => {
     this.fileData = new Uint8Array(this.reader.result);
    };
    /*this.reader.onprogress = function(data) {
      if (data.lengthComputable) {
        let progress = parseInt( ((data.loaded / data.total) * 100), 10 );
        console.log()
      }
    }*/
    console.log(files[0]);
    this.reader.readAsArrayBuffer(files[0]);
  }

  arrayBufferToBase64(buffer: Uint8Array): string {
    let binary = '';
    const len = buffer.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(buffer[i]);
    }
    return btoa(binary);
}

  checkFileExt(fileExt: string): boolean {
    // tslint:disable-next-line:max-line-length
    if (!fileExt.match(/.jpg|.jpeg|.bmp|.png|.gif|.tiff|.pdf|.doc|.docx|.xls|.xlsx|.JPG|.JPEG|.BMP|.PNG|.GIF|.TIFF|.PDF|.DOC|.DOCX|.XLS|.XLSX/i)) {
      return false;
    }
    return true;
  }

  async handleFileInput(files: FileList) {
    console.log('first log');
    this.showInvalidFileMessage = false;
    if (files.length !== 1) {
      console.log('Only support upload 1 file');
      this.resetFileInput();
      return;
    }
    // File size limit, 11M
    if (files[0].size > 11534336) {
      this.InvalidFileMessage = "This file's size exceeds the limit";
      this.showInvalidFileMessage = true;
      this.resetFileInput();
      return;
    }
    console.log('Inside handle');
    console.log(files.length);
    const fileExt = files[0].name.substring(files[0].name.lastIndexOf('.')).toLowerCase();
    console.log('After handle');
    if (!this.checkFileExt(fileExt)) {
      console.log('Unsupport this kind of file');
      this.InvalidFileMessage = "We don't support " + fileExt + " file";
      this.showInvalidFileMessage = true;
      this.resetFileInput();
      return;
    }
    this.spinner.show();
    this.readFile(files);
    await this.wait2sec();
    this.questionFile.fileName =   Date.now().toString() + fileExt;
    this.question.AttachmentFilePath = this.questionFile.fileName;
    // this.questionFile.fileData = btoa(this.fileData.reduce((data, byte) => data  + String.fromCharCode(byte), ''));
    this.questionFile.fileData = this.arrayBufferToBase64(this.fileData);
    this.questionService.submitFile(this.questionFile)
    .takeWhile(() => this.alive)
    .subscribe(
      data => {
        this.spinner.hide();
        console.log(data);
      },
      err => {
        this.spinner.hide();
        this.question.AttachmentFilePath = null;
        console.log(err);
      }
    );
  }
  goToVendor() {
    this._router.navigate(['/pages/vendor']);
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }

  closeConfirmation(event) {
    this.showSuccessConfirmation = false;
    this.showFailConfirmation = false;
    this.question = new Question();
   this.selectedCategoryId = '';
   this.textAreaModel = '';
  }
  public ngOnDestroy() {
    this.alive = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-vendor/vendor-support/vendor-support.component.ts